import React, { useState } from 'react';

import { Box, Button } from '@mui/material';

import SelectCompareDraft from './SelectCompareDraft';

const DraftAction = () => {
  const [openCompareDraft, setOpenCompareDraft] = useState<boolean>(false);

  return (
    <Box>
      <Button variant="contained" onClick={() => setOpenCompareDraft(true)}>
        Compare Drafts
      </Button>
      {openCompareDraft && (
        <SelectCompareDraft
          open={openCompareDraft}
          handleClose={() => setOpenCompareDraft(false)}
        />
      )}
    </Box>
  );
};

export default DraftAction;
